import {axiosUtil} from "../../../utils/axios_util";

const signatureApi = {
    //签名管理分页查询
    getSignaturePage(data:powerSearchData) {
        return axiosUtil({
            url: '/calling/card/signature/query',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },

    //查询所有签名
    getAllEnum() {
        return axiosUtil({
            url: `/calling/card/signature/getAllEnum`,
            method: 'get',
        })
    },

    //删除签名信息
    signatureDelete(noId: string) {
        return axiosUtil({
            url: `/calling/card/signature/delete/${noId}`,
            method: 'POST',
        })
    },

//账单查询
    billPage(data:any) {
        return axiosUtil({
            url: '/calling/card/bill/query',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
}

export default signatureApi
